<!--
 * @Author: your name
 * @Date: 2022-01-11 18:03:44
 * @LastEditTime: 2022-12-07 12:38:13
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \scp-web\src\views\screenWalls\components\ScreenPanel.vue
-->
<template>
  <div
    :class="[
      'app-side',
      !isExpand && modal ? position : '',
      { modal: modal },
      { expand: !isExpand && modal },
      isScreen && screenClass,
    ]"
    @click.self="cancel"
  >
    <div
      v-if="isHandle"
      :style="position + ':' + width + 'px'"
      :class="[
        !isExpand ? 'icon-lunan-shousuocaidan' : 'icon-lunan-shousuocaidan-copy',
        ,
        !isExpand ? 'icon-translate' : '',
        ,
        position,
        'iconfont-lunan',
        'app-side-button',
      ]"
      @click="handleSwitch"
    ></div>
    <div
      :class="[
        'app-side-panel',
        position,
        { expand: !isExpand },
        { transparent: transparent },
        isScreen && screenClass,
      ]"
      :style="{ width: width + 'px', top: top + 'px' }"
    >
      <div class="app-side-panel__header" v-if="title || $slots.title">
        <slot name="title">
          <span class="app-side-panel-title">{{ title }}</span>
        </slot>
        <span>
          <i class="el-icon-close icon" title="关闭" @click.stop="cancel" v-if="!isClose">
          </i>
          <i
            class="el-icon-full-screen"
            title="全屏展示"
            style="margin: 0 10px"
            @click.stop="handleScreen"
            v-if="isScreen"
          >
          </i>
        </span>
      </div>
      <div class="app-side-panel__body">
        <!-- <el-scrollbar> -->
        <slot></slot>
        <!-- </el-scrollbar> -->
      </div>

      <div class="app-side-panel__footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppPanel",
  props: {
    position: {
      type: String,
      default: "right",
    },
    width: {
      type: Number,
      default: 700,
    },
    top: {
      type: Number,
      default: 0,
    },
    // height: {
    //   type: Number,
    //   default: 520,
    // },
    // 关闭or打开
    isExpand: {
      type: Boolean,
      default: false,
    },
    // 是否需要右上角关闭按钮
    isClose: {
      type: Boolean,
      default: false,
    },
    isScreen: {
      type: Boolean,
      default: false,
    },
    screenClass: {
      type: String,
      default: "isScreen",
    },
    // 是否需要侧边展开收起按钮
    isHandle: {
      type: Boolean,
      default: false,
    },
    // 是否需要遮罩层
    modal: {
      type: Boolean,
      default: true,
    },
    // 是否透明
    transparent: {
      type: Boolean,
      default: false,
    },
    // 面板标题，如果没有则不显示header
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    handleScreen() {
      let screen = document.getElementsByClassName(this.screenClass);
      screen[1].classList.toggle("screen");
      this.$emit("screen");
    },
    handleSwitch() {
      this.$emit("Switch");
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
// 如果app-panel作为组件二次封装，比如弹窗页面 建议父组件使用 dialog-app-panel,dialog-show 样式
// .dialog-app-panel {
//   transform: translateX(100%);
//   position: absolute;
//   top: 0;
//   width: 100%;
//   height: 100%;
//   z-index: 2;
// }
// .dialog-show {
//   transform: translateX(0%);
// }
.icon-translate {
  transform: translate(400px);
  right: 0px;
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1) 500ms;
}
.app-side {
  top: 0;
  z-index: 2;
  &.modal {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  &.expand {
    //改样式配合modal完成遮罩层样式
    transition: transform 100ms cubic-bezier(0, 0, 0.2, 1) 500ms;
    // transform: translateX(100%);
    background: rgba(0, 0, 0, 0);
  }
  &.right {
    transform: translateX(100%);
  }
  &.left {
    transform: translateX(-100%);
  }
  &-button {
    position: absolute;
    top: calc(50% - 28px);
    width: 20px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-size: 16px;
    font-weight: bolder;
    z-index: 5;
    background: #262b37;
    cursor: pointer;
    transition: all 550ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    &.left {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    &.right {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }
}
.app-side-panel {
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: absolute;
  height: calc(100% - 0px) !important;
  box-shadow: 5px 0px 30px -10px #40526d;
  &.screen {
    width: 100% !important;
  }
  @include set_theme_color(background-color, popper-bg-color);
  transition: transform 550ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  z-index: 5;

  &.transparent {
    @include set_theme_color(background-color, blur-color);
    backdrop-filter: blur(5px);
    .app-side-panel__header {
      // background: #262b37;
       @include set_theme_color(background-color, dialog-main-bg-color);
    }
    .app-side-panel__footer {
      // background: #262b37;
       @include set_theme_color(background-color, dialog-main-bg-color);
    }
  }
  &.full {
    height: calc(100% - 103px);
    top: 103px;
  }

  &.back {
    background-color: rgba(#03133c, 0.7);
  }

  &.left {
    left: 0px;

    &.expand {
      transform: translateX(-100%);
      left: 0;
    }
  }

  &.right {
    right: 0px; //0px;

    &.expand {
      transform: translateX(100%);
      right: 0;
    }
  }

  &__content {
    padding: 20px 40px;
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
  }
  &__header {
    padding: 12px 16px;
    // background-color: #1d253a;
    font-size: 14px;
    font-weight: 400;
    // color: #e1e1e1;
    border-top-left-radius: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    @include set_theme_color(background-color, dialog-main-bg-color);

    i {
      cursor: pointer;
      font-size: 17px;
      &:hover {
        @include set_theme_color(color, active-border-color);
      }
    }
  }
  &__body {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    margin: 16px;
    position: relative;
  }
  &__footer {
    text-align: right;
    padding: 7px 16px;
    @include set_theme_color(background-color, dialog-main-bg-color);
  }

  &.show {
    transform: translateX(0);
  }
}
</style>
